import { Loader2 } from "lucide-react";

export function PageSkeleton() {
  return (
    <div data-testid="page-skeleton" className="space-y-4 animate-in fade-in duration-200">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="h-5 w-32 bg-zinc-800 rounded animate-pulse" />
        <div className="h-7 w-20 bg-zinc-800 rounded animate-pulse" />
      </div>

      {/* Cards skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-16 bg-zinc-900/80 border border-zinc-800 rounded-lg animate-pulse" />
        ))}
      </div>

      {/* Main content skeleton */}
      <div className="h-64 bg-zinc-900/80 border border-zinc-800 rounded-lg flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin text-cyan-400/50" />
      </div>
    </div>
  );
}
